//Pirkka frontend v1.0
//testing
import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, combineReducers, applyMiddleware } from 'redux'
//import timerMiddleware from 'redux-timer-middleware'
import thunk from 'redux-thunk';
//import { Provider } from 'react-redux'
import App from './App'
import resultReducer from './reducers/resultReducer'
import verReducer from './reducers/verReducer'
import lastverReducer from './reducers/lastverReducer'
import {filterReducerSeries,filterReducerSeura,filterReducerLahto,filterReducerSija,
  filterReducerMaali,filterReducerEro,filterReducerHaku, filterReducerKerrat} from './reducers/filterReducer'
import { sortReducerMaali, sortReducerSarja } from './reducers/sortReducer'
import timerReducer from './reducers/timerReducer'
//import {TICK} from './actions/types'
import {startTimer } from './actions/index'

import { timerMiddleware } from './reducers/timerReducer'



const reducer = combineReducers({
  results: resultReducer,
  getResults: timerReducer,
  filterseries: filterReducerSeries,
  filterseura: filterReducerSeura,
  filterlahto: filterReducerLahto,
  filtersija: filterReducerSija,
  filtermaali: filterReducerMaali,
  filterero: filterReducerEro,
  filterhaku: filterReducerHaku,
  filterkerrat: filterReducerKerrat,
  sortmaali: sortReducerMaali,
  sortsarja: sortReducerSarja,
  lastver: lastverReducer,
  ver: verReducer
})

export const store = createStore(reducer, applyMiddleware(thunk,timerMiddleware)) //, applyMiddleware(timerMiddleware))


//store.dispatch(fetchAllResults(0))

store.dispatch(startTimer(1000))


//ReactDOM.render(
//  <Provider store={store}>
//    <App />
//  </Provider>, document.getElementById("root")
//)

const renderApp = () => {
  ReactDOM.render(
    <App store={store} />, 
  document.getElementById('root'))
}

renderApp()
store.subscribe(renderApp)
//export default store